import {
  ExperiencePerformanceTypes,
  payloadPublisher,
  TenantType
} from '@atlassian/ufo';
import { memo, version } from 'react';

import { getAnalyticsWebClient } from '../analytics';

export const SSR_PERFORMANCE_MARK = 'ssr:page';

export const setPerformanceMark = () => {
  performance.mark(SSR_PERFORMANCE_MARK);
};

const init = () => {
  payloadPublisher.setup({
    featureFlagClient: { getValue: () => true },
    product: 'platform',
    gasv3: getAnalyticsWebClient(),
    app: {
      version: { web: '1.0.0' },
      framework: { name: 'react', version }
    },
    tenantType: TenantType.RealUser,
    resourceTimings: {
      mapResources: (url) => url,
      sanitiseEndpoints: (url) => url
    },
    performanceConfig: {
      histogram: {
        [ExperiencePerformanceTypes.PageLoad]: {
          initial: {
            fmp: '1000_2000_3000_4000',
            tti: '1000_2000_3000_4000'
          },
          transition: {
            fmp: '1000_2000',
            tti: '1000_2000'
          }
        },
        [ExperiencePerformanceTypes.PageSegmentLoad]: {
          initial: {
            fmp: '1000_2000',
            tti: '1000_2000'
          },
          transition: {
            fmp: '1000_2000',
            tti: '1000_2000'
          }
        },
        [ExperiencePerformanceTypes.InlineResult]: {
          result: '1000_2000',
          response: '1000_2000'
        },
        [ExperiencePerformanceTypes.Custom]: {
          duration: '1000_2000'
        }
      }
    }
  });

  return null;
};

export const InitUFO = memo(init);
